import { defineComponent as _defineComponent } from 'vue'

import { computed, watch } from "vue";
import { useStore } from "vuex";
import { useQueryClient } from "@tanstack/vue-query";

interface NotificationPayload {
  title: string;
  message: string;
  status?: string;
  type?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationDialog',
  setup(__props) {

const store = useStore();
const queryClient = useQueryClient();

// Computed properties
const activePopup = computed(() => store.getters.activePopup as NotificationPayload | null);

// Watch for new notifications from socket
watch(activePopup, (val) => {
  if (!val) return;

  // Invalidate notifications query to refresh NotificationBell
  queryClient.invalidateQueries({ queryKey: ["notifications"] });
});

return (_ctx: any,_cache: any) => {
  return null
}
}

})